import { useEffect, useState, useContext } from 'react';
import { db, collection, where, query } from '../../fb';
import { onSnapshot, orderBy } from "firebase/firestore";
import { createProduct, updateProduct } from 'backend/db';

import Product from "./Product";
import ListProduct from "./ListProduct";

import classnames from "classnames";
import { AuthContext, User } from 'Auth';

const maxProducts: {[key: string]: number} = {
    artist: 40,
    gallery: 80,
}

function Home() {

    // const uid = getUid();
    const user: User = useContext(AuthContext);
    const [loading, setLoading] = useState(true);
    const [products, setProducts] = useState<any[]>([]);
    const [selectedProduct, setSelectedProduct] = useState<any>(null);

    useEffect(() => {
        const productsRef = collection(db, 'products');

        if (user.uid === '') {
            return;
        }

        setLoading(true);
        const q = query(productsRef, where("userId", "==", user.uid), orderBy("createdAt"));
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const products: any[] = [];
            querySnapshot.forEach((doc) => {
                products.push({
                    id: doc.id,
                    ...doc.data()
                });
            });
            if (products.length === 0 && user.uid != null) {
                createProduct(user.uid);
            } else {
                setProducts(products);
                setLoading(false);
            }
        });
        return () => unsubscribe();
    }, [user]);

    useEffect(() => {
        if (selectedProduct == null && products.length > 0) {
            setSelectedProduct(products[0]);
        }
    }, [selectedProduct, products]);

    // On submit callback
    const onSubmit = async (productId: string, values: any) => {
        return updateProduct(productId, values);
    };

    const mProducts = maxProducts[user.usertype ?? "artist"] ?? maxProducts.artist;
    return (
        <div className='relative' >
            {!loading && selectedProduct ? (
                <div className={classnames("", {
                    "mb-16": user.uid && !loading
                })}>
                    <Product product={selectedProduct} onSubmit={onSubmit} userType={user.usertype}/>
                </div>
            ) : null}
            {user.uid && !loading && <div className='fixed start-0 end-0 bottom-0 bg-gray-50 border-t border-slate-100'>
                <ListProduct selectedId={selectedProduct?.id} products={products} onChangeProduct={(p) => setSelectedProduct(p)} createProduct={() => createProduct(user.uid)} enableCreateProduct={products.length < mProducts} />
            </div>}
        </div>
    )
}

export default Home;
